/**
 * Tiny pleasant chime via WebAudio — used to signal successful actions.
 * Not distractingly loud. Respects a global mute toggle in localStorage.
 */
let ctx = null;

function ensureCtx() {
  if (typeof window === 'undefined') return null;
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

export function isChimeMuted() {
  try { return localStorage.getItem('pm_chime_muted') === '1'; } catch { return false; }
}
export function setChimeMuted(v) {
  try { localStorage.setItem('pm_chime_muted', v ? '1' : '0'); } catch { /* ignore */ }
}

/**
 * Play a short 2-tone chime.
 * kind: 'success' (default), 'error', 'info'
 */
export function chime(kind = 'success') {
  if (isChimeMuted()) return;
  const c = ensureCtx();
  if (!c) return;
  const now = c.currentTime;
  const tones = {
    success: [880, 1318.5],
    info:    [660, 990],
    error:   [440, 330],
  }[kind] || [880, 1318.5];

  tones.forEach((freq, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, now + i * 0.09);
    gain.gain.setValueAtTime(0.0001, now + i * 0.09);
    gain.gain.exponentialRampToValueAtTime(0.06, now + i * 0.09 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.09 + 0.18);
    osc.connect(gain).connect(c.destination);
    osc.start(now + i * 0.09);
    osc.stop(now + i * 0.09 + 0.2);
  });
}
